import { render } from "./Step1.vue?vue&type=template&id=6b46c989&ts=true"
import script from "./Step1.vue?vue&type=script&lang=ts"
export * from "./Step1.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/IAM-PlanCorresponsables/IAM-PlanCorresponsables/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__